import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { putField } from "../../../../utils/form";

export const callRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_TYPE", value: searchQuery });

export const callUserObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["4"].includes(item.key)));

export const callDocumentStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DOCUMENT_STATUS", value: searchQuery });

export const createColumns = ({ props }) => {
    const { columnTemplate } = props;
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.manufactureSample.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            customRender: ({ record }) => {
                if (record.refUserCompany?.refPersonType?.key === "1") {
                    return <div>{record.refUserCompany?.companyNameTh}</div>;
                }
                return <div>{record.refUserCompany?.fullNameTh}</div>;
            }
        }),
        createColumnInput({ title: () => i18n.global.t("model.manufactureSample.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.manufactureSample.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.manufactureSample.refOperation"),
            dataIndex: "refOperation.value",
            customRender: ({ record }) => <div>{record.refOperation?.value}</div>,
            inputProp: () => ({
                list: ({ searchQuery }) =>
                    callUserObjective({ searchQuery }).then(operation => operation.filter(op => ["4"].includes(op.key))),
                optLabel: "value"
            }),
            align: "center",
            search: { name: "refOperation.id" }
        }),
        /*createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            align: "center",
            search: { name: "refRequestType.id" }
        }),*/
        createColumnSelect({
            title: () => i18n.global.t("model.manufactureSample.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            align: "center",
            search: { name: "refStatus.id" }
        })
    ];

    const template1 = [
        "refUserCompany.companyNameTh",
        "approveCode",
        "expireDate",
        "refOperation.value",
        "refRequestType.value",
        "refStatus.value"
    ];
    if (columnTemplate === "template1") return columns.filter(d => template1.includes(d.dataIndex));
    return columns;
}

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
